export const rateStructure = {
  linked: "linked",
};
